var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.854 5.396a.5.5 0 0 0-.708 0L8 9.543 3.854 5.396a.5.5 0 1 0-.708.708l4.5 4.5a.5.5 0 0 0 .708 0l4.5-4.5a.5.5 0 0 0 0-.708z","fill-rule":"evenodd"}})])};var toString = function () {return "/home/jenkins/workspace/b_kiwitaxi-cabinet-client_master/src/assets/icons/chevron.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron.svg
// module id = tGMY
// module chunks = 9